import { c as _c } from "react/compiler-runtime";
// Speaker glyph shared by the closet's sound toggles: waves when sound is on,
// an "x" when it is off.
export function SoundIcon(t0) {
  const $ = _c(2);
  const {
    soundEnabled
  } = t0;
  let t1;
  if ($[0] !== soundEnabled) {
    t1 = <svg className="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">{soundEnabled ? <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15.54 8.46a5 5 0 010 7.07m2.83-9.9a9 9 0 010 12.73M5.59 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.59l4.71-4.71C10.92 3.66 12 4.11 12 5v14c0 .891-1.08 1.34-1.71.707L5.59 15z" /></> : <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5.59 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.59l4.71-4.71C10.92 3.66 12 4.11 12 5v14c0 .891-1.08 1.34-1.71.707L5.59 15z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2" /></>}</svg>;
    $[0] = soundEnabled;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}